import { render } from "./FaceGenerator.vue?vue&type=template&id=34b6c360&scoped=true"
import script from "./FaceGenerator.vue?vue&type=script&lang=js"
export * from "./FaceGenerator.vue?vue&type=script&lang=js"

import "./FaceGenerator.vue?vue&type=style&index=0&id=34b6c360&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34b6c360"]])

export default __exports__